import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { assignedResidencies } from '@app/features/residences/residency-label';
import { LabelValue } from '@app/shared/forms/label-value/label-value';
import { AssignmentFormValue } from '../../embauche-tabs-form/assignment-form/assignment-form';

@Component({
  selector: 'app-assignment-view',
  imports: [LabelValue, MatTooltipModule],
  templateUrl: './assignment-view.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './assignment-view.scss',
})
export class AssignmentView {
  assignment = input.required<AssignmentFormValue>();
  /** L'affectation d'avant un avenant : si elle diffère, elle est surlignée (RG-avenant-consultation). */
  previous = input<AssignmentFormValue | null>(null);

  get assignmentValue(): string {
    return label(this.assignment());
  }

  change(): string | null {
    const previous = this.previous();
    if (!previous) {
      return null;
    }
    const current = this.assignment();
    const before = assignedResidencies(previous.assignmentType, previous.residencies);
    const after = assignedResidencies(current.assignmentType, current.residencies);
    const same =
      previous.assignmentType === current.assignmentType &&
      before.length === after.length &&
      before.every((residency) => after.includes(residency));
    return same ? null : `Avant l'avenant : ${label(previous)}`;
  }
}

function label(assignment: AssignmentFormValue): string {
  switch (assignment.assignmentType) {
    case 'SPECIFIC': {
      const residencies = assignment.residencies;
      if (!residencies || residencies.length === 0) {
        return 'Aucune résidence';
      } else {
        return `${residencies.length} résidence(s)`;
      }
    }
    case 'TOURNEE':
      return 'Tournée';
    default:
      return 'N/D';
  }
}
